'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageDetailController = function ImageDetailController(Image, $uibModal) {
  "ngInject";

  (0, _classCallCheck3.default)(this, ImageDetailController);
  var vm = this;
  vm.$onInit = function () {
    if (vm.resolve && vm.resolve.imageSource) {
      vm.imageSource = vm.resolve.imageSource;
    }
  };

  vm.deleteImage = function () {
    $uibModal.open({
      component: 'confirmDialog',
      windowClass: 'modal-mini modal-primary',
      resolve: {
        message: function message() {
          return "Confermi di voler cancellare l'immagine selezionata?";
        }
      }
    }).result.then(function () {
      Image.deleteImage(vm.resolve.imageId).then(function () {
        if (_lodash2.default.isFunction(vm.resolve.callback)) {
          vm.resolve.callback();
          vm.close();
        }
      });
    });
  };
};

exports.default = ImageDetailController;


// WEBPACK FOOTER //
// ./client/app/common/imageDetail/imageDetail.controller.js